import useTypedSWR from 'src/components/general/useTypedSWR';
import { PATIENT_HEADER_HIGHLIGHTS_QUERY } from 'src/patientHeader/components/badges/queries/patientHighlights.gql';

export const useSWRPatientHighlights = (patientId: string) =>
  useTypedSWR([PATIENT_HEADER_HIGHLIGHTS_QUERY, { patientId }]);
